import { EMPTY_VALUE } from '../../utils/common'

export const isNotEmptyStr = (str = []) => {
  return !!str.length
}

export const getAllTitleColumnsPackages = (data) => {
  const allReportTypes = Object.values(
    data
      .filter((item) => item.isReportNameRow)
      .reduce((acc, curr) => {
        acc[curr.reportTypeId] = curr
        return acc
      }, {}),
  ).map((item) => ({
    id: item.reportTypeId,
    name: item.name,
    isReportNameRow: item.isReportNameRow,
  }))

  const allChildrenOfReportTypes = Object.values(
    data
      .filter((item) => !item.isReportNameRow)
      .reduce((acc, curr) => {
        acc[curr.reportTypeId] = curr
        return acc
      }, {}),
  ).map((item) => ({
    reportTypeId: item.reportTypeId,
    name: item.name,
    isReportNameRow: item.isReportNameRow,
    id: item.reportTypeId,
    parentId: item.parentId,
  }))

  const getChildrenRowOfReports = (reportTypeId) => {
    const childrens = allChildrenOfReportTypes.filter(
      (item) => item.parentId === reportTypeId,
    )
    return childrens.map((item, index) => ({
      ...item,
      isLastOffer: index === childrens.length - 1,
    }))
  }

  const allReportTypesWithChildren = allReportTypes
    .map((item) => [item, ...getChildrenRowOfReports(item.id)])
    .flat(1)

  return allReportTypesWithChildren
}

export const convertPricingPackages = (data) => {
  const uniquePlans = Object.values(
    data.reduce((acc, curr) => {
      acc[curr.packageId] = curr
      return acc
    }, {}),
  )

  const getDataByPackageId = (packageId) => {
    return data
      ?.filter((item) => item.packageId === packageId)
      ?.map((item) => ({
        value: item.value,
        reportTypeId: item.reportTypeId,
      }))
  }

  const getDataValue = uniquePlans.map((item) => [
    ...getDataByPackageId(item.packageId),
  ])

  const getDataKey = [...new Set(data?.map((item) => item.userTypeCode))]

  const getCorrespondingDataWithKey = (data, item) => {
    return (
      data[data.indexOf(data.find((i) => i.reportTypeId === item.id))]?.value ??
      EMPTY_VALUE
    )
  }

  const getKeyAndValRange = (item) => {
    let dataKeyAndValRange = []
    getDataKey.forEach(
      (key, i) =>
        (dataKeyAndValRange[key] = getCorrespondingDataWithKey(
          getDataValue[i],
          item,
        )),
    )
    return dataKeyAndValRange
  }

  return getAllTitleColumnsPackages(data).map((item) => ({
    ...item,
    ...getKeyAndValRange(item),
  }))
}

export const convertUniquePackageTypes = (
  data,
  valueKey,
  isParentKey,
  reportTypeId,
) => {
  const uniqueReportTypes = data
    .filter((item) => item[isParentKey])
    .map((item) => ({
      id: item.reportTypeId,
      name: item.reportName,
      pricingPackageId: item.id,
    }))

  const getQuantityDiscountedPrice = (id) => {
    return data
      .filter((item) => item[reportTypeId] === id)
      .map((item) => ({
        ...item,
        quantity: item.quantity,
        price: item[valueKey],
        pricingPackageId: item.id,
      }))
  }

  return uniqueReportTypes.map((item) => ({
    ...item,
    discountedPrice: getQuantityDiscountedPrice(item.id),
  }))
}

export const getMaxDiscountVal = (planTypeId, data, discountPercentageKey) => {
  const dataByUserType = data?.filter((item) => item.packageId === planTypeId)
  const allDiscountedPrice = dataByUserType.map(
    (item) => item[discountPercentageKey] || 0,
  )

  return Math.max(...allDiscountedPrice) || null
}
